/* eslint-disable */
import React, { useCallback, useState, useEffect } from 'react'
import { Breadcrumb, Tabs, Button } from 'antd'
import { withQuery } from '@/utils'
import styles from './bills.module.scss'
import { getTenantById } from '@/models/tenants/services'
import UnbilledList from './UnbilledList'
import BillList from './BillList'

function Section({ title, children }) {
  return (
    <div className={styles.section}>
      <div className={styles.sectionTitle}>{title}</div>
      <div className={styles.sectionBody}>{children}</div>
    </div>
  )
}

function Bills(props) {
  const { query, history, match, location } = props
  const tenantId = props.tenantId || match.params.id
  const [tenant, setTenant] = useState(null)
  const activeKey = query.type || 'billed'

  useEffect(() => {
    if (/^\/enterprises\//.test(location.pathname)) {
      getTenantById(tenantId)
        .then(result => setTenant(result))
    }
  }, [tenantId])

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <Breadcrumb>
          {tenant && (
            <Breadcrumb.Item>{tenant.short_name || tenant.name}</Breadcrumb.Item>
          )}
          <Breadcrumb.Item>账单</Breadcrumb.Item>
        </Breadcrumb>
      </div>
      <div style={{paddingTop: 10}}>
        <Tabs
          activeKey={activeKey}
          className={styles.tabs}
          onChange={activeKey => {
            history.push(`/enterprises/${tenantId}/bills?type=${activeKey}`)
          }}
          type="card">
          <Tabs.TabPane key="billed" tab="历史账单">
            <BillList tenantId={tenantId} />
          </Tabs.TabPane>
          <Tabs.TabPane key="unbilled" tab="未出账单">
            <UnbilledList tenantId={tenantId} />
          </Tabs.TabPane>
        </Tabs>
      </div>
    </div>
  )
}

export default withQuery(Bills)
